import React from 'react';
import { useTranslation } from 'react-i18next';

function UnauthorizedPanel({ links }) {
    const { t } = useTranslation();
    const blockRegisterAndLogin = process.env.MIX_OPTION_BLOCK_REGISTER_AND_LOGIN.toLowerCase() === 'true';

    function getContent() {
        if (blockRegisterAndLogin) {
            return null;
        }

        return (
            <>
                <div key="register" className="registration d-none d-xl-flex">
                    <a className="btn btn-dark btn-left" href={links.register} rel="nofollow">
                        {t('userPanel.register')}
                    </a>
                </div>
                <div key="login" className="login d-none d-xl-flex">
                    <a className="btn btn-dark btn-right" href={links.login} rel="nofollow">
                        {t('userPanel.logIn')}
                    </a>
                </div>
            </>
        );
    }

    return getContent();
}

export default UnauthorizedPanel;
